import { Component, forwardRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { BaseUiFormControl } from '../base-ui-form-control';
import { Calendar } from 'primeng/calendar';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ControlContainer, FormControl, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui-date',
  templateUrl: './ui-date.component.html',
  styleUrls: ['./ui-date.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:  forwardRef(() => UiDateComponent),
    multi: true
  }]
})
export class UiDateComponent extends BaseUiFormControl implements OnChanges {

  @Input() placeHolder: string = 'MM/DD/YYYY';
  @Input() touchUI: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() datesDisabled?: Date[];
  @Input() daysDisabled?: string;
  @Input() view: string = "date";               //only valid values are "month" and "date"
  @Input() endOfMonth: boolean = false;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() defaultDate?: Date;
  @Input() showOnFocus: boolean = true; //KNOWN ISSUE: this version of primeng throws an error when tabbing away if showOnFocus is false. Fix would be to update primeng.
  @Input() monthNavigator: boolean = false;
  @Input() yearNavigator: boolean = false;

  @ViewChild('cal') cal: Calendar;                                                                                                                                                                                                                             

  currentDate: Date = new Date();
  year: number = this.currentDate.getFullYear()-144;
  month: number = this.currentDate.getMonth();
  date: number = this.currentDate.getDate();

  yearRange: string;

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit() {
    //Parse max/min date to Date if passed in as strings
    if (this.minDate && typeof this.minDate == "string") this.minDate = new Date(Date.parse(this.minDate));
    if (this.maxDate && typeof this.maxDate == "string") this.maxDate = new Date(Date.parse(this.maxDate));

    if (this.yearNavigator) {
      let minYear = this.minDate ? this.minDate.getFullYear() : new Date().getFullYear() - 144;
      let maxYear = this.maxDate ? this.maxDate.getFullYear() : new Date().getFullYear() + 10;

      this.yearRange = minYear + ":" + maxYear;
    }

    //Alter the placeHolder if in month mode
    if (this.view == 'month' && this.placeHolder == 'MM/DD/YYYY') this.placeHolder = 'MM/YYYY';
  }

  ngOnChanges(changes: SimpleChanges) {
    //Nothing yet.... not needed? remove after testing
  }

  get value() {
    return this.control.value;
  }
  set value(value) {
    this.onChange(value);
    this.onTouched();
  }
  onChange: any = () => {};
  onTouched: any = () => {};
  registerOnChange(fn) {
    this.onChange = fn;
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      //this.control.reset();
    }
  }
  setDisabledState(isDisabled: boolean): void {
    if(isDisabled)
      this.control.disable();
    else
      this.control.enable();
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  validate(_: FormControl) {
    return this.control.valid ? null : { profile: { valid: false } };
  }
  clear() {

  }

  /* Opens/closes the calendar in the event that showOnFocus is false. Responds to click or to the space bar. */
  onToggle(value?) {
    //Check for the showOnFocus setting & whether event source is calendar's input element
    if (!this.showOnFocus && (value.srcElement == this.cal.inputfieldViewChild.nativeElement)) this.cal.toggle();
  }

  /* Makes adjustments to the selected date based on special conditions. Right now, that means
     skipping to the end of the month if flag set. */
  onDateSelect(event?) {
    if (this.view == 'month' && this.endOfMonth) {
      this.control.setValue(new Date(event.getFullYear(), event.getMonth() + 1, 0, 23, 59, 59));
    }
  }

}
